import {Alert} from '@material-ui/lab'
import BusyDialog from './BusyDialog'
import {AllFieldsMessage, Root, Title} from './styled'
import {ButtonCancel, ButtonSave, ButtonsBox} from './styled'
import SuccessDialog from './SuccessDialog'

export type EditTemplateProps = {
  title: string
  busyString?: string
  successString?: string
  errorMessage?: string
  allFieldsRequired?: boolean
  children: React.ReactNode
  onSave: () => void
  onCancel: () => void
  onDismissSuccess: () => void
}

const EditTemplate: React.FC<EditTemplateProps> = ({
  title,
  busyString,
  successString,
  errorMessage,
  allFieldsRequired,
  onSave,
  onCancel,
  onDismissSuccess,
  children,
}: EditTemplateProps) => {
  return (
    <Root>
      <Title>{title}</Title>
      {children}
      {allFieldsRequired && <AllFieldsMessage>All fields are required.</AllFieldsMessage>}
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      <ButtonsBox display="flex" flexDirection="row-reverse">
        <ButtonSave onClick={onSave}>Save</ButtonSave>
        <ButtonCancel onClick={onCancel} color="secondary">
          Cancel
        </ButtonCancel>
      </ButtonsBox>
      <SuccessDialog title={successString} onDismiss={onDismissSuccess} />
      <BusyDialog message={busyString} />
    </Root>
  )
}

export default EditTemplate
